// full page layout
import {Header} from "./Header";

export function Layout({children}){
    return(
        <>
            <Header />
            <main>
                {children}
            </main>
        </>
    )
}